import { addYears, format, subYears } from 'date-fns';
import { DateFormatStringType, formatStrings } from "../data/dates";


export function formattedDate(date: string | Date | null | undefined, formatString: DateFormatStringType = 'FULL_DATE'): string {
    if (date) {
        try {
            const parsedDate = typeof date === 'string' ? new Date(date) : date;
            return format(parsedDate, formatStrings[formatString]);
            //return format(new Date(date), formatStrings[formatString]);
        } catch (error) {
        }
    }
    return '';
}


export const yearsFromNow = (years: number, dateFormat: string = 'yyyy-MM-dd'): string => {
    const futureDate = addYears(new Date(), years)
    return format(futureDate, dateFormat)
}


export const yearsAgo = (years: number, dateFormat: string = 'yyyy-MM-dd'): string => {
    const pastDate = subYears(new Date(), years)
    return format(pastDate, dateFormat)
}